
// import React, { useMemo } from 'react';
// import { useSelector, useDispatch } from 'react-redux';
// import { removeFromCompare, clearCompare } from '../redux/compareSlice'
// import Navigation from '../component/navigation';
// import { Card, Col, Row } from 'react-bootstrap';
// import { selectProducts } from '../redux/productSlice';
// import { Navigate, useParams } from 'react-router-dom';
// import { calculateDiscountAndFinalPrice } from '../utils/priceCalculation';

// const Compare = ({compareLimit }) => {

//   const dispatch = useDispatch();

   

//     const compareItems = useSelector(state => state.compare.compareItems);
//   console.log(compareItems)
//     const handleRemoveProduct = (productId) => {
//       dispatch(removeFromCompare(productId));
//     };
  
//     const handleClearCompare = () => {
//       dispatch(clearCompare());
//     };

   
//     return (
//       <>
     
//          <Navigation />
//         <h3>Compare Products</h3>
//         {compareItems.length === 0 ? (
//           <p>No products to compare.</p>
//         ) : (

//          <Row>
//           <button  onClick={handleClearCompare}>Clear All</button>
//            {compareItems.slice(0, compareLimit).map(product => (
//             <Col md={4}  key={product.id} className="mb-1 ps-2 pe-2 mb-sm-3 mainProductCart">
//               <Card className="productCard">
//                 <div className="productsThumb">
//                   <div className="productsThumbLink">
//                     {product.discount && (
//                       <div className="productLabel">
//                         <span className="onsale">-{product.discount}%</span>
//                       </div>
//                     )}
//                      <button style={{position:'absolute',top:'10px',right:'10px',fontSize:'10px'}} onClick={() => handleRemoveProduct(product.id)}>Remove</button>
//                     <div className="productImg">
//                       <img src={product.image} alt={product.name} />
//                     </div>
//                   </div>
//                 </div>
//                 <div className="productCaption">
                 
//                   <div className="productName">
//                   <div
   
//             >
//                       <h3>{product.name}</h3>
//                     </div>
//                   </div>
//                   <div className="productPrize d-block mt-2 mt-sm-0 d-sm-flex align-items-center justify-content-between w-100">
//                     {product.discount ? (
//                       <>
//                         <h4 className="discountedPrice">${product.finalPrice.toFixed(2)}</h4>
//                         <h4 className="originalPrice">
//                           <del style={{ fontSize: '13px', opacity: '0.6' }}>${product.price.toFixed(2)}</del>
//                         </h4>
//                       </>
//                     ) : (
//                       <h4>${product.price.toFixed(2)}</h4>
//                     )}
//                   </div>
//                   <div className=''>
//                   {product.specifications.map((spec, index) => (
//                 <div key={index} className="spec-item">
//                   <h3>{spec.title}</h3>
//                   {/* Check if the description is an array (list) or string */}
//                   {Array.isArray(spec.description) ? (
//                     <ul>
//                       {spec.description.map((desc, i) => (
//                         <li key={i}>{desc}</li>
//                       ))}
//                     </ul>
//                   ) : (
//                     <p>{spec.description}</p>
//                   )}
//                 </div>
//               ))}
//                   </div>
//                 </div>
//               </Card>
//            </Col>
//                ))}
//          </Row>
            
          
//         )}
     
      
//       </>
    
//     );
//   };
  
// export default Compare;


import React, { useMemo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row, Button } from 'react-bootstrap';
import Navigation from "../component/navigation";
import CompareProduct from '../component/compareProduct'; // Import the new component
import useProductActions from '../utils/productThanos';

const Compare = ({ compareLimit }) => {    

const {compareItems, handleClearCompare } = useProductActions();
//  const compareItems = useSelector(state => state.compare.compareItems);
// const compareItems = useSelector(state => state.compare.compareItems);

  return (
    <>
      <Navigation />
      <h3>Compare Products</h3>
      {(compareItems?.length || 0) === 0 ? (
        <p>No products to compare.</p>
      ) : (
        <>
          <Button onClick={handleClearCompare}>Clear All</Button>
          <Row>
            {compareItems.slice(0, compareLimit).map(product => (
              <CompareProduct 
                key={product.id} 
                product={product} 
                // onRemove={() => handleRemoveCompare(product.id)}
              />
            ))}
          </Row>
        </>
      )}
    </>
  );
};

export default Compare;